import React from 'react';
import { IconProps } from '../types';
const MinecraftPotionOverlay: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="8" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(99, 99, 99, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(99, 99, 99, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(197, 197, 197, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(197, 197, 197, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(99, 99, 99, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(170, 170, 170, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(197, 197, 197, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(197, 197, 197, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(197, 197, 197, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(197, 197, 197, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(148, 148, 148, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(197, 197, 197, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(166, 166, 166, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(99, 99, 99, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(197, 197, 197, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(166, 166, 166, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(99, 99, 99, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(99, 99, 99, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(154, 154, 154, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(99, 99, 99, 255)" />
</svg>);
export default MinecraftPotionOverlay;